import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const GIT = () => {
  return (
    <StartInterviewLayout type="git"/>
  )
}

export default GIT;